<template>

    <h3 class="text-primary">
      <i class="fa fa-file me-2"></i> {{ $t("dashboard.myInvoices") }}
    </h3>
    <p class="text-muted">{{ $t("invoices.info") }}</p>

    <!-- Filtrare facturi -->
    <div class="filter-section">
      <label class="form-label"><i class="fa fa-filter me-1"></i> {{ $t("invoices.filterType") }}</label>
      <select v-model="selectedType" class="form-select">
        <option value="all">{{ $t("invoices.all") }}</option>
        <option value="invoice">{{ $t("invoices.invoice") }}</option>
        <option value="storno">{{ $t("invoices.storno") }}</option>
      </select>
    </div>

    <!-- Listă Facturi -->
    <div class="table-responsive" v-if="filteredInvoices.length">
      <table class="table table-striped table-hover rounded">
        <thead class="bg-primary text-white">
          <tr class="text-center">
            <th>#</th>
            <th><i class="fa fa-user me-1"></i> {{ $t("invoices.client") }}</th>
            <th><i class="fa fa-calendar me-1"></i> {{ $t("invoices.date") }}</th>
            <th><i class="fa fa-usd me-1"></i> {{ $t("invoices.currency") }}</th>
            <th><i class="fa fa-money me-1"></i> {{ $t("invoices.totalAmount") }}</th>

            <th><i class="fa fa-cogs me-1"></i> {{ $t("invoices.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in filteredInvoices" :key="invoice.id" class="text-center">
            <td>#{{ invoice.id }}</td>
<td>
  <template v-if="invoice.client">
    {{ invoice.client }}
  </template>
  <template v-else>
    <span class="text-muted">-</span>
  </template>
</td>

            <td>{{ new Date(invoice.issue_date).toLocaleDateString() }}</td>
            <td>{{ invoice.currency }}</td>
<td :class="{'text-danger': invoice.is_storno}">
  <i v-if="invoice.is_storno" class="fa fa-minus-circle text-danger me-1"></i>
  <template v-if="invoice.is_online && invoice.total_amount_ron">
    {{ invoice.total_amount_ron }} RON
  </template>
  <template v-else>
    {{ invoice.total_amount }} {{ invoice.currency }}
  </template>
</td>

<td class="text-center align-middle">
  <div class="d-flex justify-content-center align-items-center gap-2">
  <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
    @click="downloadPDF(invoice.id, false, invoice.currency)">
    <i class="fa fa-file me-1"></i> {{ $t("invoices.downloadPDF") }}
  </button>

  <button v-if="invoice.is_storno" class="btn btn-outline-danger btn-sm d-flex align-items-center"
    @click="downloadPDF(invoice.id, true, invoice.currency)">
    <i class="fa fa-file me-1"></i> {{ $t("invoices.downloadStornoPDF") }}
  </button>
  </div>
</td>

          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mesaj dacă nu există facturi -->
    <div v-else class="alert alert-warning text-center">
      <i class="fa fa-info-circle me-2"></i> {{ $t("invoices.noInvoices") }}
    </div>

</template>

  
  <script>
  import axios from "axios";
  
  export default {
    name: "MyInvoices",
    data() {
      return {
        invoices: [],
        stornoInvoices: [],
        selectedType: "all",
      };
    },
async mounted() {
  await this.fetchInvoices();
}
,
computed: {
  filteredInvoices() {
    return this.invoices.filter(invoice => {
      return (
        this.selectedType === "all" ||
        (this.selectedType === "invoice" && !invoice.is_storno) ||
        (this.selectedType === "storno" && invoice.is_storno)
      );
    });
  }
}
,
    methods: {
async fetchInvoices() {
  try {
    const response = await axios.get("https://api.feribot-eurobac.ro/client/api/invoices/client/", {
      withCredentials: true,
    });

    // ✅ Sortăm facturile descrescător după issue_date (data emiterii)
this.invoices = response.data.invoices.map(invoice => {
  // ✅ Dacă este factură online și are rata de schimb, conversie la RON
  if (invoice.currency === "RON" && invoice.exchange_rate) {
    invoice.total_amount_ron = (invoice.total_amount * invoice.exchange_rate).toFixed(2);
  }
  return invoice;
}).sort((a, b) => new Date(b.issue_date) - new Date(a.issue_date));


  } catch (error) {
    console.error("Eroare la preluarea facturilor:", error);
  }
}

,

async downloadPDF(invoiceId, isStorno, currency) {
  try {
      let endpointBase = "https://api.feribot-eurobac.ro/api/invoices";

  // Detectăm tipul de factură pe baza ID-ului
  let invoiceType;
  if (invoiceId.includes("RON")) {
    invoiceType = "ron";
  } else if (currency === "EUR") {
    invoiceType = "eur";
  } else {
    invoiceType = "online";  // Orice altceva este considerat online
  }

  // Construim endpoint-ul pe baza tipului de factură
  let endpoint;
  if (isStorno) {
    endpoint = `${endpointBase}/stornare/${invoiceType}/${invoiceId}/pdf/`;
  } else {
    endpoint = `${endpointBase}/${invoiceType}/${invoiceId}/pdf/`;
  }

    const response = await axios.get(endpoint, {
      withCredentials: true,
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `Factura_${invoiceId}.pdf`;
    link.click();
  } catch (error) {
    console.error("Eroare la descărcarea facturii:", error);
  }
}

    }
  };
  </script>
<style scoped>
/* Container General */
.invoice-container {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
}

/* Filtrare */
.filter-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.form-select {
  max-width: 250px;
}

/* Stilizare tabel */
.table {
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}

.table thead {
  background-color: #007bff !important;
  color: white;
}

.table tbody tr:hover {
  background: rgba(0, 123, 255, 0.1);
}

/* Butoane */
.btn-outline-primary,
.btn-outline-danger {
  transition: 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #fff;
}

/* Mesaj de eroare */
.alert {
  font-size: 1rem;
  font-weight: bold;
  padding: 10px;
}
</style>

